import React, { Component } from 'react';
import { Text, Animated } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import { isUndefined as _isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import ContentManager from '../../ContentManager';
import { LightThemeColors, AllowFontScalingContext, withTheme } from '../Themes';

import styles from './VFText.Styles';

class VFText extends Component {
  getTranslationMethod = localize => {
    if (!localize) {
      return key => key;
    }

    return ContentManager.translate;
  };

  render() {
    const {
      i18nKey,
      placeHolders,
      translateOption,
      localize,
      style,
      type,
      children,
      theme,
      testID,
      accessibilityLabel,
      testKey,
      ...props
    } = this.props;

    const allowFontScaling = this.context;
    const translationMethod = this.getTranslationMethod(localize);

    return (
      <Text
        style={[styles.text(theme), type && styles[type](theme), style]}
        {...props}
        accessibilityRole="text"
        accessibilityTraits="text"
        allowFontScaling={
          _isUndefined(allowFontScaling) ? props.allowFontScaling : allowFontScaling
        }
        testID={testID || testKey || accessibilityLabel}
      >
        {children || translationMethod(i18nKey, placeHolders, translateOption)}
      </Text>
    );
  }
}

VFText.contextType = AllowFontScalingContext;

VFText.defaultProps = {
  localize: true,
  theme: LightThemeColors,
};

VFText.propTypes = {
  i18nKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeHolders: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number])),
    PropTypes.string,
  ]),
  translateOption: PropTypes.object,
  style: TextPropTypes.style,
  type: PropTypes.string,
  localize: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  allowFontScaling: PropTypes.bool,
  testID: PropTypes.string,
  testKey: PropTypes.string,
  children: PropTypes.node,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export const AnimatedVFText = withTheme(Animated.createAnimatedComponent(VFText));

export default withTheme(VFText);
